/*
  <x-drawer-fancy> — a drop-in <x-drawer> subclass with a plain slide-in transition
  (no clip-path wipe) for the USP banner drawer block only. Registered lazily against
  whatever "x-drawer" resolves to, so it never touches the shared Drawer implementation
  other drawers (cart, search, size chart, ...) rely on.
*/
(function () {
  customElements.whenDefined('x-drawer').then(function () {
    if (customElements.get('x-drawer-fancy')) return;

    var BaseDrawer = customElements.get('x-drawer');
    if (!BaseDrawer) return;

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function axisFor(openFrom) {
      return openFrom === 'bottom' || openFrom === 'top' ? 'Y' : 'X';
    }

    function offscreenValueFor(openFrom) {
      if (openFrom === 'left') return '-100%';
      if (openFrom === 'top') return '-100%';
      return '100%';
    }

    var FancyDrawer = class extends BaseDrawer {
      _showTransition(animate) {
        if (animate === undefined) animate = true;

        this._setInitialPosition();

        if (prefersReducedMotion || !animate) {
          return super._showTransition(animate);
        }

        var content = this.shadowRoot.querySelector('[part="content"]');
        var axis = axisFor(this.openFrom);
        var offscreen = offscreenValueFor(this.openFrom);

        this.animate(
          [
            { opacity: 0, visibility: 'hidden' },
            { opacity: 1, visibility: 'visible' },
          ],
          { duration: 150, easing: 'ease-out', fill: 'both' }
        );

        var contentAnimation = content.animate(
          [
            { transform: 'translate' + axis + '(' + offscreen + ')' },
            { transform: 'translate' + axis + '(0)' },
          ],
          { duration: 350, easing: 'cubic-bezier(0.4, 0, 0.2, 1)', fill: 'both' }
        );

        var self = this;
        return contentAnimation.finished
          .then(function () {
            self.classList.add('show-close-cursor');
          })
          .catch(function () {});
      }

      _hideTransition() {
        if (prefersReducedMotion) {
          return super._hideTransition();
        }

        var content = this.shadowRoot.querySelector('[part="content"]');
        var axis = axisFor(this.openFrom);
        var offscreen = offscreenValueFor(this.openFrom);

        var contentAnimation = content.animate(
          [
            { transform: 'translate' + axis + '(0)' },
            { transform: 'translate' + axis + '(' + offscreen + ')' },
          ],
          { duration: 300, easing: 'cubic-bezier(0.4, 0, 1, 1)', fill: 'both' }
        );

        var hostAnimation = this.animate(
          [
            { opacity: 1, visibility: 'visible' },
            { opacity: 0, visibility: 'hidden' },
          ],
          { duration: 150, delay: 200, easing: 'ease-in', fill: 'both' }
        );

        var self = this;
        return contentAnimation.finished
          .then(function () {
            return hostAnimation.finished;
          })
          .then(function () {
            self.classList.remove('show-close-cursor');
          })
          .catch(function () {});
      }
    };

    customElements.define('x-drawer-fancy', FancyDrawer);
  });
})();
